import { render, staticRenderFns } from "./FormatColumns.vue?vue&type=template&id=7c6a724e"
import script from "./FormatColumns.vue?vue&type=script&lang=js"
export * from "./FormatColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports